import { useEffect, useRef, useState, createElement } from 'react';
import './index.scss';
const StreamList = ({ children, onNextPage, onRefreshPage, refreshingText = '正在刷新中...', loadingText = '加载中...', loadMoreText = '加载更多', isLastPage = false, nowPage = 1, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const threshold = 50;
    const maxPullDistance = 100;
    const [pullDistance, setPullDistance] = useState(0);
    const startYRef = useRef(0);
    const [isDragging, setIsDragging] = useState(false);
    const observerRef = useRef(null);
    const hasInitialLoad = useRef(false);
    useEffect(() => {
        if (isRefreshing || isLastPage) {
            return;
        }
        const spinElement = document.querySelector('.spin');
        if (spinElement && !observerRef.current) {
            observerRef.current = new IntersectionObserver((entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && !isLoading) {
                    setIsLoading(true);
                    const nextPage = nowPage + 1;
                    onNextPage({
                        page: nextPage,
                    })
                        .then((res) => { })
                        .catch((err) => {
                        console.error('加载下一页失败:', err);
                    })
                        .finally(() => setIsLoading(false));
                }
            }, { threshold: 0.4 });
            observerRef.current.observe(spinElement);
        }
        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
        };
    }, [nowPage, isLoading, isRefreshing, isLastPage]);
    useEffect(() => {
        hasInitialLoad.current = true;
    }, []);
    const handleTouchStart = (e) => {
        startYRef.current = 'touches' in e ? e.touches[0].clientY : e.clientY;
        setIsDragging(true);
    };
    const handleTouchMove = (e) => {
        if (isRefreshing || (!isDragging && !('touches' in e)))
            return;
        const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
        const distance = clientY - startYRef.current;
        if (distance > 0 && distance <= maxPullDistance) {
            setPullDistance(distance);
        }
        else if (distance > maxPullDistance) {
            setPullDistance(maxPullDistance);
        }
    };
    const handleTouchEnd = async () => {
        setIsDragging(false);
        if (pullDistance > threshold) {
            setIsRefreshing(true);
            setPullDistance(0);
            onRefreshPage()
                .then((res) => { })
                .catch((err) => {
                console.error('刷新失败:', err);
            })
                .finally(() => {
                setIsRefreshing(false);
            });
        }
        else {
            setPullDistance(0);
        }
    };
    return (createElement("div", { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, onMouseDown: handleTouchStart, onMouseMove: handleTouchMove, onMouseUp: handleTouchEnd, className: "stream-list-container" },
        createElement("div", { className: "refresh-indicator", style: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                transform: `translateY(${isRefreshing ? threshold : pullDistance}px)`,
                transition: isRefreshing || pullDistance === 0 ? 'transform 0.3s ease' : 'none',
            } }, isRefreshing && createElement("span", null, refreshingText)),
        createElement("div", { style: {
                transform: `translateY(${isRefreshing ? threshold : pullDistance}px)`,
                transition: 'transform 0.3s ease',
            } }, children),
        !isRefreshing &&
            !isLastPage &&
            (isLoading ? (createElement("div", { className: "loading-text" }, loadingText)) : (createElement("div", { className: "spin" }, loadMoreText)))));
};
StreamList.displayName = 'StreamList';
export default StreamList;
